import script from "./UNotify.vue?vue&type=script&setup=true&lang=js"
export * from "./UNotify.vue?vue&type=script&setup=true&lang=js"

import "./UNotify.vue?vue&type=style&index=0&id=291b1cc1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-291b1cc1"]])

export default __exports__